import { getIndexAbove, sortByIndex } from "../..";
export const ensurePaywallProductsHaveUniqueIndexes = (store)=>{
    const paywallProducts = store.query.records("paywall_product").get();
    const indexes = new Set([
        ...paywallProducts.map((p)=>p.index)
    ]);
    if (indexes.size === paywallProducts.length) {
        return;
    }
    const sortedProducts = paywallProducts.sort(sortByIndex);
    let currentIndex = "a0";
    const productsWithUpdatedIndexes = sortedProducts.map((product)=>{
        product.index = currentIndex;
        currentIndex = getIndexAbove(currentIndex);
        return product;
    });
    store.put(productsWithUpdatedIndexes);
};
